<template>
  <div>
    <menu-bar></menu-bar>
    <el-row :gutter="20" style="width: 1400px;margin: 0 auto">
      <el-col :span="14" :offset="5">
        <el-card style="margin-top: 24px" v-loading="loading">
          <div class="grid-content bg-purple" style="padding: 10px;display: flex">
            <div style="width: 30%;text-align: center">
              <div class="image-container" style="width: 215px;display: flex;align-items: center;justify-content: center;min-height: 142px">
                <img style="width: 185px" :src="itemData.iconUrl"/>
              </div>
            </div>
            <div style="width: 69%;margin-left: 1%;position: relative">
              <div style="font-weight: 600;font-size: 24px">
                {{ itemData.cnName }}
              </div>
              <div style="font-size: 18px">
                {{ itemData.engName }}
              </div>
              <div style="margin-top: 8px" :style="formatterRarity(itemData.rarityName)">
                {{ itemData.rarityName }}
              </div>
              <div style="position: absolute;bottom: 0px">
                <div style="margin-top: 8px;display: flex;align-items: center">
                  <div style="font-size: 18px;margin-right: 8px"> 最低售价</div>
                  <div class="text-color-orange mr-15 text-28" style="font-size: 24px;color: orange">
                    {{ platformData.length != 0 ? ('¥ ' + platformData[0].price.toFixed(3)) : '暂无数据' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 磨损度切换按钮组 -->
          <div class="wear-btn-group">
            <div
              v-for="wear in wearOptions"
              :key="wear.key"
              class="wear-btn"
              :class="{ 'wear-active': isWearActive(wear.key) }"
              @click="switchWearByWear(wear.key)"
            >
              {{ wear.label }}
              <span class="wear-price">¥{{ wear.price || '--' }}</span>
            </div>
            <!-- 纪念品按钮（如果有数据） -->
            <div
              v-if="souvenirPrice !== null"
              class="wear-btn"
              :class="{ 'wear-active': isSouvenirActive() }"
              @click="switchWearByType('souvenir')"
            >
              <span class="special-icon">🎖</span>纪
              <span class="wear-price">¥{{ souvenirPrice || '--' }}</span>
            </div>
            <!-- 暗金按钮 -->
            <div
              v-if="statTrakPrice !== null"
              class="wear-btn"
              :class="{ 'wear-active': isStatTrakActive() }"
              @click="switchWearByType('stattrak')"
            >
              <span class="special-icon">⭐</span>ST
              <span class="wear-price">¥{{ statTrakPrice || '--' }}</span>
            </div>
          </div>

          <!-- 图表数据切换 -->
          <div style="display: flex; gap: 12px; padding: 8px 10px 0 10px; border-top: 1px solid #e8ecf1; margin-top: 8px;align-items: center">
            <span style="font-size: 13px; color: #666; line-height: 28px;">显示数据：</span>
            <el-checkbox v-model="showPrice" @change="updateChart">价格</el-checkbox>
            <el-checkbox v-model="showOnSell" @change="updateChart">在售量</el-checkbox>
          </div>

        </el-card>

        <el-tabs style="margin-top: 12px" type="border-card" v-model="activeTab">
          <el-tab-pane label="历史走势" name="tradeHistory">
            <div id="tradingview-container" style="height: 560px; width: 100%;"></div>
          </el-tab-pane>
          <el-tab-pane label="平台数据" name="platformData">
            <el-table
              :data="platformData"
              style="width: 100%">
              <el-table-column
                prop="platform"
                width="160"
                label="来源">
                <template slot-scope="props">
                  <div style="color: #979cae;font-size: 16px;padding-left: 24px">{{ props.row.platform }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                label="售价">
                <template slot-scope="props">
                  {{ (props.row == null || props.row.price == null) ? '' : ('¥ ' + props.row.price.toFixed(3)) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="onSell"
                label="当前在售">
                <template slot-scope="props">
                  {{ (props.row.onSell == null || props.row.onSell == 0) ? '' : (props.row.onSell + '件') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="上次更新于">
              </el-table-column>
              <el-table-column
                prop="action"
                width="140px"
                label="">
                <template slot-scope="props">
                  <el-button size="small" type="primary" style="margin-right: 12px"
                             @click="routerChanger(props.row.router)">
                    前去购买
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {auditDailyInfo} from "../../api/api";
import {formatterRarity} from "../../api/util";
import MenuBar from "../Menu/menuBar.vue";

export default {
  name: "itemPage",
  components: {MenuBar},
  data() {
    return {
      similarItem: {
        regularSkins: [],
        statTrakSkins: []
      },
      itemData: {},
      activeTab: 'tradeHistory',
      currentWear: 'fn',
      currentWearType: 'normal',
      currentWearKey: 'fn',
      wearOptions: [
        { key: 'fn', label: '崭新出厂', price: null },
        { key: 'mw', label: '略有磨损', price: null },
        { key: 'ft', label: '久经沙场', price: null },
        { key: 'ww', label: '破损不堪', price: null },
        { key: 'bs', label: '战痕累累', price: null }
      ],
      souvenirPrice: null,
      statTrakPrice: null,
      platformData: [],
      tvChart: null,
      // 存储所有磨损度的价格数据
      wearPriceData: {
        fn: [],
        mw: [],
        ft: [],
        ww: [],
        bs: [],
        souvenir: [],
        stattrak: []
      },
      // 在售量数据
      onSellData: [],
      chartLoaded: false,
      marketHashName: '', // 改为响应式数据
      // 图表显示控制
      showPrice: true,
      showOnSell: false,
      loading: false // 添加 loading 状态
    }
  },
  mounted() {
    // 从路由获取 marketHashName
    this.marketHashName = this.$route.query.marketHashName || ''
    if (this.marketHashName) {
      // 从 marketHashName 解析磨损信息
      this.parseWearFromMarketHashName(this.marketHashName)
      this.loadChartLibrary(this.marketHashName)
    }
  },
  // 监听路由变化
  watch: {
    '$route.query.marketHashName': {
      handler(newVal) {
        if (newVal && newVal !== this.marketHashName) {
          this.marketHashName = newVal
          // 从 marketHashName 解析磨损信息
          this.parseWearFromMarketHashName(newVal)
          this.resetState()
          this.loadChartLibrary(newVal)
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.tvChart) {
      this.tvChart.remove();
      this.tvChart = null;
    }
  },
  methods: {
    // 从 marketHashName 解析磨损信息
    parseWearFromMarketHashName(marketHashName) {
      if (!marketHashName) return;

      // 检查是否是纪念品
      if (marketHashName.startsWith('Souvenir ')) {
        this.currentWearType = 'souvenir';
        this.currentWear = 'souvenir';
        // 提取磨损度
        const wearMatch = marketHashName.match(/\(([^)]+)\)$/);
        if (wearMatch) {
          const wearText = wearMatch[1];
          const wearKey = this.getWearKeyFromText(wearText);
          if (wearKey) {
            this.currentWearKey = wearKey;
          }
        }
        return;
      }

      // 检查是否是暗金
      if (marketHashName.startsWith('StatTrak™ ')) {
        this.currentWearType = 'stattrak';
        this.currentWear = 'stattrak';
        const wearMatch = marketHashName.match(/\(([^)]+)\)$/);
        if (wearMatch) {
          const wearText = wearMatch[1];
          const wearKey = this.getWearKeyFromText(wearText);
          if (wearKey) {
            this.currentWearKey = wearKey;
          }
        }
        return;
      }

      // 普通磨损
      this.currentWearType = 'normal';
      const wearMatch = marketHashName.match(/\(([^)]+)\)$/);
      if (wearMatch) {
        const wearText = wearMatch[1];
        const wearKey = this.getWearKeyFromText(wearText);
        if (wearKey) {
          this.currentWearKey = wearKey;
          this.currentWear = wearKey;
        }
      }
    },

    // 根据磨损文本获取对应的 key
    getWearKeyFromText(wearText) {
      const wearMap = {
        'Factory New': 'fn',
        'Minimal Wear': 'mw',
        'Field-Tested': 'ft',
        'Well-Worn': 'ww',
        'Battle-Scarred': 'bs'
      };
      return wearMap[wearText] || null;
    },

    // 判断普通磨损按钮是否激活
    isWearActive(wearKey) {
      return this.currentWear === wearKey && this.currentWearType === 'normal';
    },
    // 判断纪念品按钮是否激活
    isSouvenirActive() {
      return this.currentWearType === 'souvenir';
    },
    // 判断暗金按钮是否激活
    isStatTrakActive() {
      return this.currentWearType === 'stattrak';
    },
    // 重置状态
    resetState() {
      // 不重置 currentWear 相关，因为会从 marketHashName 重新解析
      this.wearOptions.forEach(opt => opt.price = null)
      this.souvenirPrice = null
      this.statTrakPrice = null
      this.platformData = []
      this.itemData = {}
      this.wearPriceData = {
        fn: [], mw: [], ft: [], ww: [], bs: [],
        souvenir: [], stattrak: []
      }
      this.onSellData = []
      if (this.tvChart) {
        this.tvChart.remove()
        this.tvChart = null
      }
    },
    loadChartLibrary(marketHashName) {
      if (window.LightweightCharts) {
        this.chartLoaded = true;
        this.loadItemData(marketHashName);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/lightweight-charts@4.1.0/dist/lightweight-charts.standalone.production.js';
      script.onload = () => {
        this.chartLoaded = true;
        this.loadItemData(marketHashName);
      };
      script.onerror = () => {
        console.warn('CDN 加载失败');
        this.loadItemData(marketHashName);
      };
      document.head.appendChild(script);
    },
    showDailyTradeInfo(engName) {
      let routeUrl = this.$router.resolve({
        path: "/itemPage",
        query: {marketHashName: engName}
      });
      window.open(routeUrl.href, '_blank');
    },
    formatterRarity(val) {
      return formatterRarity(val)
    },
    switchWear(wearKey) {
      if (wearKey === 'souvenir') {
        this.currentWearType = 'souvenir';
      } else if (wearKey === 'stattrak') {
        this.currentWearType = 'stattrak';
      } else {
        this.currentWearType = 'normal';
        this.currentWearKey = wearKey;
      }
      this.currentWear = wearKey;
      const newMarketHashName = this.buildMarketHashName(
        this.currentWearType,
        this.currentWearKey
      );
      // 更新路由，不刷新页面
      this.$router.replace({
        path: '/ItemPage',
        query: { marketHashName: newMarketHashName }
      });
    },
    switchWearByWear(wearKey) {
      this.currentWearKey = wearKey;
      this.currentWear = wearKey;
      this.currentWearType = 'normal';
      const newMarketHashName = this.buildMarketHashName(
        this.currentWearType,
        wearKey
      );
      this.$router.replace({
        path: '/ItemPage',
        query: { marketHashName: newMarketHashName }
      });
    },
    switchWearByType(type) {
      this.currentWearType = type;
      const wearKey = this.currentWearKey || 'fn';
      if (type === 'souvenir') {
        this.currentWear = 'souvenir';
      } else if (type === 'stattrak') {
        this.currentWear = 'stattrak';
      }
      const newMarketHashName = this.buildMarketHashName(type, wearKey);
      this.$router.replace({
        path: '/ItemPage',
        query: { marketHashName: newMarketHashName }
      });
    },
    buildMarketHashName(type, wearKey) {
      // 从当前 itemData 中获取基础名称
      let baseName = this.itemData.baseName || this.marketHashName || ''

      // 移除已有的前缀和后缀
      baseName = baseName
        .replace(/^Souvenir\s+/, '')
        .replace(/^StatTrak™\s+/, '')
        .replace(/\s*\([^)]*\)\s*$/, '');

      const wearMap = {
        'fn': 'Factory New',
        'mw': 'Minimal Wear',
        'ft': 'Field-Tested',
        'ww': 'Well-Worn',
        'bs': 'Battle-Scarred'
      };
      const wearSuffix = wearMap[wearKey] || 'Factory New';

      if (type === 'souvenir') {
        return `Souvenir ${baseName} (${wearSuffix})`;
      } else if (type === 'stattrak') {
        return `StatTrak™ ${baseName} (${wearSuffix})`;
      } else {
        return `${baseName} (${wearSuffix})`;
      }
    },
    formatDateToTimestamp(dateStr) {
      if (!dateStr) return null;
      const str = dateStr.replace('.0', '');
      return new Date(str).getTime() / 1000;
    },
    loadItemData(marketHashName) {
      if (!marketHashName) return;

      this.loading = true; // 开始加载

      auditDailyInfo({
        engName: marketHashName
      }).then(json => {
        const data = json.data;
        this.itemData = data.itemData || {};
        // 保存基础名称用于构建其他磨损度名称
        if (this.itemData.engName) {
          this.itemData.baseName = this.itemData.engName
            .replace(/^Souvenir\s+/, '')
            .replace(/^StatTrak™\s+/, '')
            .replace(/\s*\([^)]*\)\s*$/, '');
        }
        this.platformData = data.platformData || [];
        this.similarItem.regularSkins = (data.similarItem && data.similarItem.regularSkins) || [];
        this.similarItem.statTrakSkins = (data.similarItem && data.similarItem.statTrakSkins) || [];

        // 解析所有数据
        this.parseAllData(data);

        this.$nextTick(() => {
          this.initTradingViewChart();
          this.updateChart();
          this.loading = false; // 加载完成
        });
      }).catch(err => {
        console.error('加载数据失败:', err);
        this.loading = false; // 加载失败也要关闭 loading
        this.$message({
          message: '加载数据失败，请稍后重试',
          type: 'error'
        });
      });
    },
    parseAllData(data) {
      const priceData = data.thirdMinPrices || [];
      const regularSkins = (data.similarItem && data.similarItem.regularSkins) || [];
      const statTrakSkins = (data.similarItem && data.similarItem.statTrakSkins) || [];
      const souvenirSkins = (data.similarItem && data.similarItem.souvenirSkins) || [];

      // 解析价格数据
      const wearFactors = {
        fn: 1.0,
        mw: 0.75,
        ft: 0.55,
        ww: 0.45,
        bs: 0.40
      };

      Object.keys(wearFactors).forEach(key => {
        this.wearPriceData[key] = priceData.map(item => ({
          time: this.formatDateToTimestamp(item[0]),
          value: parseFloat((item[1] * wearFactors[key]).toFixed(2))
        }));
      });

      // 暗金价格
      this.wearPriceData.stattrak = priceData.map(p => ({
        time: this.formatDateToTimestamp(p[0]),
        value: parseFloat((p[1] * 0.85).toFixed(2))
      }));

      // 纪念品价格
      this.wearPriceData.souvenir = priceData.map(item => ({
        time: this.formatDateToTimestamp(item[0]),
        value: parseFloat((item[1] * 0.6).toFixed(2))
      }));

      // 更新按钮价格
      const wearMap = {
        '崭新出厂': 'fn',
        '略有磨损': 'mw',
        '久经沙场': 'ft',
        '破损不堪': 'ww',
        '战痕累累': 'bs'
      };

      regularSkins.forEach(item => {
        const key = wearMap[item.label];
        if (key) {
          const opt = this.wearOptions.find(o => o.key === key);
          if (opt && item.minPrice !== null && item.minPrice !== undefined) {
            opt.price = item.minPrice.toFixed(2);
          }
        }
      });

      const statTrakFn = statTrakSkins.find(item => item.label === '崭新出厂');
      if (statTrakFn && statTrakFn.minPrice !== null) {
        this.statTrakPrice = statTrakFn.minPrice.toFixed(2);
      }

      const souvenirFn = souvenirSkins.find(item => item.label === '崭新出厂');
      if (souvenirFn && souvenirFn.minPrice !== null) {
        this.souvenirPrice = souvenirFn.minPrice.toFixed(2);
      }

      // 解析第三方在售量数据 (thirdOnSells)
      this.onSellData = (data.thirdOnSells || []).map(item => ({
        time: this.formatDateToTimestamp(item[0]),
        value: item[1] || 0
      }));

      // 判断当前选中的磨损度是否可用，如果不可用则切换到第一个可用的
      this.ensureValidWearSelection();
    },
    // 确保当前选中的磨损度有效
    ensureValidWearSelection() {
      // 检查普通磨损是否可用
      const normalWearExists = this.wearOptions.some(opt => opt.price !== null);

      // 如果当前是普通磨损且没有可用数据，切换到第一个可用的
      if (this.currentWearType === 'normal') {
        const currentOpt = this.wearOptions.find(opt => opt.key === this.currentWearKey);
        if (!currentOpt || currentOpt.price === null) {
          // 找第一个可用的磨损
          const firstAvailable = this.wearOptions.find(opt => opt.price !== null);
          if (firstAvailable) {
            this.currentWearKey = firstAvailable.key;
            this.currentWear = firstAvailable.key;
            // 更新路由
            const newMarketHashName = this.buildMarketHashName('normal', firstAvailable.key);
            this.$router.replace({
              path: '/ItemPage',
              query: { marketHashName: newMarketHashName }
            });
          }
        }
      }

      // 检查纪念品是否可用
      if (this.currentWearType === 'souvenir' && this.souvenirPrice === null) {
        // 尝试切换到普通磨损
        const firstAvailable = this.wearOptions.find(opt => opt.price !== null);
        if (firstAvailable) {
          this.currentWearType = 'normal';
          this.currentWearKey = firstAvailable.key;
          this.currentWear = firstAvailable.key;
          const newMarketHashName = this.buildMarketHashName('normal', firstAvailable.key);
          this.$router.replace({
            path: '/ItemPage',
            query: { marketHashName: newMarketHashName }
          });
        }
      }

      // 检查暗金是否可用
      if (this.currentWearType === 'stattrak' && this.statTrakPrice === null) {
        const firstAvailable = this.wearOptions.find(opt => opt.price !== null);
        if (firstAvailable) {
          this.currentWearType = 'normal';
          this.currentWearKey = firstAvailable.key;
          this.currentWear = firstAvailable.key;
          const newMarketHashName = this.buildMarketHashName('normal', firstAvailable.key);
          this.$router.replace({
            path: '/ItemPage',
            query: { marketHashName: newMarketHashName }
          });
        }
      }
    },
    initTradingViewChart() {
      const container = document.getElementById('tradingview-container');
      if (!container) return;

      if (this.tvChart) {
        this.tvChart.remove();
        this.tvChart = null;
      }

      const LW = window.LightweightCharts;
      if (!LW) {
        container.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:16px;">图表加载中...</div>';
        return;
      }

      this.tvChart = LW.createChart(container, {
        width: container.clientWidth,
        height: 560,
        layout: {
          background: { color: '#ffffff' },
          textColor: '#333',
        },
        grid: {
          vertLines: { color: '#f0f0f0' },
          horzLines: { color: '#f0f0f0' },
        },
        leftPriceScale: {
          borderColor: '#cccccc',
          visible: true,
          scaleMargins: {
            top: 0.2,
            bottom: 0.2,
          },
        },
        rightPriceScale: {
          borderColor: '#cccccc',
          visible: true,
          scaleMargins: {
            top: 0.2,
            bottom: 0.2,
          },
        },
        timeScale: {
          borderColor: '#cccccc',
          timeVisible: true,
          secondsVisible: false,
        },
        crosshair: {
          mode: 0,
        },
        handleScroll: {
          mouseWheel: true,
          pressedMouseMove: true,
        },
        handleScale: {
          axisPressedMouseMove: true,
          mouseWheel: true,
          pinch: true,
        },
      });
    },
    updateChart() {
      if (!this.tvChart) return;

      const LW = window.LightweightCharts;
      if (!LW) return;

      const container = document.getElementById('tradingview-container');
      if (!container) return;

      // 清除旧图表重新创建
      this.tvChart.remove();
      this.tvChart = LW.createChart(container, {
        width: container.clientWidth,
        height: 560,
        layout: {
          background: { color: '#ffffff' },
          textColor: '#333',
        },
        grid: {
          vertLines: { color: '#f0f0f0' },
          horzLines: { color: '#f0f0f0' },
        },
        leftPriceScale: {
          borderColor: '#cccccc',
          visible: true,
          scaleMargins: {
            top: 0.2,
            bottom: 0.2,
          },
        },
        rightPriceScale: {
          borderColor: '#cccccc',
          visible: true,
          scaleMargins: {
            top: 0.2,
            bottom: 0.2,
          },
        },
        timeScale: {
          borderColor: '#cccccc',
          timeVisible: true,
          secondsVisible: false,
        },
        crosshair: {
          mode: 0,
        },
        handleScroll: {
          mouseWheel: true,
          pressedMouseMove: true,
        },
        handleScale: {
          axisPressedMouseMove: true,
          mouseWheel: true,
          pinch: true,
        },
      });

      // 获取当前磨损度的价格数据
      const priceData = this.wearPriceData[this.currentWearKey] || [];

      // 1. 价格曲线 (右侧Y轴)
      if (this.showPrice) {
        const validPriceData = priceData.filter(item => item.time && item.value > 0);
        if (validPriceData.length > 0) {
          const priceSeries = this.tvChart.addLineSeries({
            color: '#2962FF',
            lineWidth: 2,
            priceLineVisible: true,
            lastValueVisible: true,
            priceScaleId: 'right',
            title: '价格',
          });
          priceSeries.setData(validPriceData);
        }
      }

      // 2. 在售量曲线 (左侧Y轴 - 独立比例尺)
      if (this.showOnSell) {
        const onSellData = this.onSellData.filter(item => item.time && item.value >= 0);
        if (onSellData.length > 0) {
          const onSellSeries = this.tvChart.addLineSeries({
            color: '#FF6B6B',
            lineWidth: 1.5,
            priceLineVisible: false,
            lastValueVisible: true,
            priceScaleId: 'left',
            title: '在售量',
          });
          onSellSeries.setData(onSellData);
        }
      }

      // 如果没有数据显示，显示空状态
      const hasData = (this.showPrice && priceData.some(d => d.value > 0)) ||
        (this.showOnSell && this.onSellData.some(d => d.value >= 0));

      if (!hasData) {
        const noDataSeries = this.tvChart.addLineSeries({
          color: '#999999',
          lineWidth: 1,
          priceScaleId: 'right',
        });
        const now = Math.floor(Date.now() / 1000);
        noDataSeries.setData([
          { time: now - 86400, value: 0 },
          { time: now, value: 0 }
        ]);
      }

      this.tvChart.timeScale().fitContent();
    },
    routerChanger(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  text-align: center;
  background: url(../HomePage/background.jpg) 50% no-repeat;
  background-size: cover;
}

.wear-btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 10px 4px 10px;
  border-top: 1px solid #e8ecf1;
  margin-top: 16px;
}

.wear-btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 16px;
  background: #f5f6fa;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 2px solid transparent;
  user-select: none;
}

.wear-btn:hover {
  background: #e8ecf1;
  transform: translateY(-1px);
}

.wear-btn.wear-active {
  background: #1a73e8;
  color: #fff;
  border-color: #1a73e8;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}

.wear-btn .wear-price {
  font-size: 12px;
  margin-left: 4px;
  opacity: 0.8;
}

.wear-btn.wear-active .wear-price {
  opacity: 1;
}

.wear-btn .special-icon {
  margin-right: 2px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .wear-btn {
    padding: 4px 10px;
    font-size: 12px;
  }
  .wear-btn .wear-price {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/itemPage/index.vue